import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import $ from "jquery";
import { action, flow, makeObservable, observable, runInAction, set } from "mobx";
import { request } from "../utils/request.js";
import { locationRestTermsDelete } from "../wp-api/terms.delete.js";
import { locationRestTermsPut } from "../wp-api/terms.put.js";
class CategoryNode {
    id;
    icon = "";
    iconActive = "";
    childNodes = [];
    title = "";
    count = 0;
    selected = false;
    $busy = false;
    $droppable = true;
    $visible = true;
    properties;
    parent;
    treeStore;
    constructor(categoryNode, treeStore){
        this.treeStore = treeStore;
        makeObservable(this);
        runInAction(()=>{
            set(this, categoryNode);
            if (this.id) {
                treeStore.refs.set(this.id, this);
            }
        });
    }
    static mapFromRestEndpoint({ term_id, name, count, childNodes, ...rest }) {
        return new CategoryNode({
            id: term_id,
            title: name,
            count,
            icon: "folder",
            iconActive: "folder-open",
            childNodes: childNodes ? childNodes.map(CategoryNode.mapFromRestEndpoint.bind(this)) : [],
            properties: rest
        }, this);
    }
    setTitle = flow(function*(name) {
        this.$busy = true;
        try {
            const result = yield request({
                location: locationRestTermsPut,
                params: {
                    id: +this.id
                },
                request: {
                    name: name,
                    taxonomy: this.properties.taxonomy
                }
            });
            this.title = name;
            this.properties = $.extend({}, this.properties, result);
            return result;
        } finally{
            this.$busy = false;
        }
    });
    trash = flow(function*() {
        this.$busy = true;
        try {
            yield request({
                location: locationRestTermsDelete,
                params: {
                    id: +this.id,
                    taxonomy: this.properties.taxonomy
                }
            });
            this.$visible = false;
        } finally{
            this.$busy = false;
        }
    });
    /**
     * Do not use it directly, it is automatically used by TreeStore#persist.
     */ addChildNode(node) {
        node.parent = this;
        this.childNodes.push(node);
    }
    setSelected(state) {
        if (state) {
            this.treeStore.setSelected(this);
            return;
        }
        if (this.treeStore.selected === this) {
            this.treeStore.setSelected(undefined);
        }
    }
    setBusy(state) {
        this.$busy = state;
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], CategoryNode.prototype, "id", void 0);
_ts_decorate([
    observable
], CategoryNode.prototype, "icon", void 0);
_ts_decorate([
    observable
], CategoryNode.prototype, "iconActive", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Array)
], CategoryNode.prototype, "childNodes", void 0);
_ts_decorate([
    observable
], CategoryNode.prototype, "title", void 0);
_ts_decorate([
    observable
], CategoryNode.prototype, "count", void 0);
_ts_decorate([
    observable
], CategoryNode.prototype, "selected", void 0);
_ts_decorate([
    observable
], CategoryNode.prototype, "$busy", void 0);
_ts_decorate([
    observable
], CategoryNode.prototype, "$droppable", void 0);
_ts_decorate([
    observable
], CategoryNode.prototype, "$visible", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], CategoryNode.prototype, "properties", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], CategoryNode.prototype, "parent", void 0);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], CategoryNode.prototype, "addChildNode", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Boolean
    ]),
    _ts_metadata("design:returntype", void 0)
], CategoryNode.prototype, "setSelected", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Boolean
    ]),
    _ts_metadata("design:returntype", void 0)
], CategoryNode.prototype, "setBusy", null);
export { CategoryNode };
